import { Box } from "sprout-ui-primitives";
import { themeGet } from "sprout-ui-theme";
import styled from "styled-components";
import { layoutPadding } from "./styles";
const PostPageCard = styled(Box)`
  ${layoutPadding}

  box-shadow: 0 0 0 ${themeGet("colors.black.10")};
  background: ${themeGet("colors.white.100")};

  border-radius: 30px;

  padding-top: 48px;
  padding-bottom: 48px;
`;
export default PostPageCard;
